var $table;
var pageSize;
var pageIndex;
$(document).ready(function(){
	
	$table = $("#link-table");
	pageSize = 30;
	pageIndex = 0;
	
	refreshTable();
	
	$(".pager-list").on("click","a.page",function(){
		
		var pIndex = parseInt($(this).html()) - 1;
		
		pageIndex = pIndex;
		refreshTable();		
	});
	
	$(".pager-prevnext.prev").click(function(){			
		if(pageIndex > 0){
			pageIndex--;
			refreshTable();
		}
	});
	
	$(".pager-prevnext.next").click(function(){
		if(pageIndex < getPageNum() - 1){
			pageIndex++;
			refreshTable();
		}
	});
	
	$( document ).on( "hotel_filter_event", function( event ) {
		pageIndex=0;
		refreshTable();
		$("#avail-result").html('<span class="result-total"><span>'+getTotalHotelCount()+' '+ FmtMessage.getMessage('js.hotel.results.found') +' </span></span><span class="result-total"><span>'+getAvailableHotelCount()+' '+ FmtMessage.getMessage('js.hotel.results.available') +' </span></span>');
	})
});

function getVisibleHotelCount(){
	return $table.find("tr[data-visible=true]").length;
}

function getAvailableHotelCount(){
	return $table.find("tr[any-available=true]").length;
}

function getTotalHotelCount(){
	return $table.find('tr').length;
}


function getPageNum(){
	var visibleHotelCount = getVisibleHotelCount();
	if(visibleHotelCount == 0){
		$("#avail-result").hide();
		$(".resultNotFound").show();
	}else{
		$("#avail-result").show()
		$(".resultNotFound").hide();
	}
	return Math.ceil(visibleHotelCount / pageSize);
}

function refreshTable(){
	var pageNum = getPageNum();
	
	$("#pager-totalResult").text(getVisibleHotelCount());
	$table.find("tr").hide();
	$table.find("tr[data-visible=true]").slice(pageSize * pageIndex,pageSize * (pageIndex + 1)).show();
	
	if(pageNum <= 1){
		$(".pager-list").hide();
	} else {
		$(".pager-list").show();
		TABLE_PAGER.setPage(pageIndex, pageNum);	
	}
}